import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader } from '../../ui/card';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger
} from '../../../components/ui/accordion';
import { useState } from 'react';
import Entity from '../entity/Entity';
import { cn } from '../../../../common-utils/libraries/tailwind/utils';
import Icon from '../icon/Icon';

/**
 * @param root0
 * @param root0.accordion
 * @param root0.titleEntity
 * @param root0.children
 * @param root0.cardClassName
 * @param root0.namespace
 * @param root0.icon
 * @returns {JSX} Panel
 */
function Panel({ accordion, titleEntity, children, cardClassName, namespace, icon }) {

    const [open, setOpen] = useState(false);

    if (accordion) {
        return (
            <Card className={cn('bg-muted border px-2', cardClassName)}>
                <Accordion type='multiple' defaultValue={['item-1']}>
                    <AccordionItem value='item-1'>
                        <CardHeader className='p-2'>
                            <AccordionTrigger open={open} onClick={() => setOpen(!open)}>
                                <Entity entity={titleEntity} />
                            </AccordionTrigger>
                        </CardHeader>
                        <AccordionContent>
                            <CardContent className='bg-white rounded-sm p-4'>
                                {children}
                            </CardContent>
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </Card>
        );
    }

    return (
        <Card className='bg-muted border p-2'>
            {
                titleEntity &&
                <CardHeader className='p-2 pb-4'>
                    <div className='justify-center text-xl flex align-middle gap-1'>
                        <Icon icon={icon} />
                        <Entity entity={titleEntity} namespace={namespace} />
                    </div>
                </CardHeader>
            }
            <CardContent className='bg-white rounded-sm'>
                {children}
            </CardContent>
        </Card>
    );
}
Panel.propTypes = {
    accordion: PropTypes.element,
    titleEntity: PropTypes.string,
    children: PropTypes.any,
    cardClassName: PropTypes.string,
    namespace: PropTypes.string,
    icon: PropTypes.string
};
export default Panel;